import { Box, IconButton, Typography } from "@mui/material";
import { CloseButton } from "@rentablo/components";
import ArrowLeft from "@icons/myicons/arrow-left.svg?react";

interface Props {
  title: string;
  onClose: () => void;
  onBack?: () => void;
  backAriaLabel?: string;
}

export const CenteredModalHeader = ({
  title,
  onClose,
  onBack,
  backAriaLabel,
}: Props) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={2}
    pb={4}
    flexShrink={0}
  >
    {onBack && (
      <IconButton size="medium" onClick={onBack} aria-label={backAriaLabel}>
        <ArrowLeft width={34} height={34} />
      </IconButton>
    )}
    <Typography variant="h5" noWrap sx={{ flex: 1, textAlign: "center" }}>
      {title}
    </Typography>
    <CloseButton onClose={onClose} />
  </Box>
);
